import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingCart, User, LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import { Button } from './ui/button';
import LoginModal from './LoginModal';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

const Header = () => {
  const { user, login, logout } = useAuth();
  const { getCartCount } = useCart();
  const navigate = useNavigate();
  const cartCount = getCartCount();
  const [showLoginModal, setShowLoginModal] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/80">
      <div className="container mx-auto px-4 py-3 md:py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img src="/youseful-logo.svg" alt="Youseful Logo" className="h-10 md:h-12" />
          </Link>

          <nav className="hidden lg:flex items-center space-x-6 xl:space-x-8">
            <Link to="/products" className="text-gray-700 hover:text-red-600 font-medium transition-colors">
              Products
            </Link>
            <Link to="/#how-it-works" className="text-gray-700 hover:text-red-600 font-medium transition-colors">
              How It Works
            </Link>
            <Link to="/#transparency" className="text-gray-700 hover:text-red-600 font-medium transition-colors">
              Transparency
            </Link>
            <Link to="/#designers" className="text-gray-700 hover:text-red-600 font-medium transition-colors">
              Designers
            </Link>
          </nav>

          <div className="flex items-center space-x-2 md:space-x-4">
            <Button
              variant="ghost"
              size="icon"
              className="relative"
              onClick={() => navigate('/cart')}
            >
              <ShoppingCart className="h-5 w-5" />
              {cartCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                  {cartCount}
                </span>
              )}
            </Button>

            {user ? (
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant="ghost" size="icon">
                    <User className="h-5 w-5" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-48">
                  <DropdownMenuItem onClick={() => navigate('/dashboard')}>
                    Dashboard
                  </DropdownMenuItem>
                  {user.role === 'consumer' && (
                    <>
                      <DropdownMenuItem onClick={() => navigate('/orders')}>
                        My Orders
                      </DropdownMenuItem>
                      <DropdownMenuItem onClick={() => navigate('/role-selection')}>
                        Switch Role
                      </DropdownMenuItem>
                    </>
                  )}
                  {user.role === 'designer' && (
                    <DropdownMenuItem onClick={() => navigate('/designer')}>
                      Designer Portal
                    </DropdownMenuItem>
                  )}
                  {user.role === 'investor' && (
                    <DropdownMenuItem onClick={() => navigate('/investor')}>
                      Investor Portal
                    </DropdownMenuItem>
                  )}
                  {user.role === 'institutional' && (
                    <DropdownMenuItem onClick={() => navigate('/dashboard')}>
                      Company Dashboard
                    </DropdownMenuItem>
                  )}
                  {user.role === 'admin' && (
                    <DropdownMenuItem onClick={() => navigate('/admin')}>
                      Admin Panel
                    </DropdownMenuItem>
                  )}
                  <DropdownMenuItem onClick={logout}>
                    <LogOut className="mr-2 h-4 w-4" />
                    Logout
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            ) : (
              <>
                <Button onClick={() => setShowLoginModal(true)} className="bg-red-600 hover:bg-red-700 text-sm md:text-base px-3 md:px-4">
                  Login
                </Button>
                <Button onClick={() => navigate('/role-selection')} variant="outline" className="hidden sm:flex text-sm md:text-base">
                  Join as Partner
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
      
      <LoginModal isOpen={showLoginModal} onClose={() => setShowLoginModal(false)} />
    </header>
  );
};

export default Header;
